import { ConfigElementWithSource, ConfigType } from "types/generated";
import { isSpaceliftConfig } from "utils/config";

export const configArray = (
  configElements: ConfigElementWithSource[] = []
): (ConfigElementWithSource & { id: string })[][] => {
  return configElements.reduce<(ConfigElementWithSource & { id: string })[][]>(
    ([localVariables, spaceliftVariables, mountedFiles], elem) => {
      const elemWithId = { ...elem, id: elem.element.id };
      if (isSpaceliftConfig(elem)) {
        return [localVariables, [...spaceliftVariables, elemWithId], mountedFiles];
      } else {
        if (elem.element.type === ConfigType.EnvironmentVariable) {
          return [[...localVariables, elemWithId], spaceliftVariables, mountedFiles];
        } else if (elem.element.type === ConfigType.FileMount) {
          return [localVariables, spaceliftVariables, [...mountedFiles, elemWithId]];
        }
      }
      return [localVariables, spaceliftVariables, mountedFiles];
    },
    [[], [], []]
  );
};
